export default "__VITE_ASSET__6e696a28__"